import { Facebook, Instagram, Mail, Phone, Pinterest, Room, Twitter } from '@mui/icons-material';
import React from 'react'
import styled from "styled-components";
import { mobile } from '../responsive';

const Container = styled.div`
display: flex;
${mobile({flexDirection: "column"})}
`;

const Left = styled.div`
flex: 1;
display: flex;
padding: 20px;
flex-direction: column;
`;

const Logo = styled.h1``;

const Desc = styled.p`
margin: 20px 0;
`;

const SocialContainer = styled.div`
display: flex;
`;

const SocialIcon = styled.div`
height: 40px;
width: 40px;
border-radius: 50%;
color: white;
background-color: #${props => props.color};
display: flex;
justify-content: center;
align-items: center;
margin-right: 20px;
`;

const Center = styled.div`
flex: 1;
padding: 20px;
${mobile({display: "none"})}
`;

const Title = styled.h3`
margin-bottom: 30px;
`;

const List = styled.ul`
list-style: none;
margin: 0;
padding: 0;
display: flex;
flex-wrap: wrap;
`;

const ListItem = styled.li`
width: 50%;
margin-bottom: 20px;
`;

const Right = styled.div`
flex: 1;
padding: 20px;
${mobile({backgroundColor: "#fff8f8"})}
`;

const ContactItem = styled.div`
display: flex;
align-items: center;
margin-bottom: 20px;
`;

const Payment = styled.img`
width: 50%;
`;



const Footer = () => {
  return (
    <Container>
      <Left>
        <Logo>LAMA.</Logo>
        <Desc>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis
          neque incidunt dolor soluta deleniti cupiditate quibusdam explicabo
          molestiae voluptatum vero ipsam hic itaque modi, distinctio minus.
          Voluptatum accusantium quia cupiditate?
        </Desc>
        <SocialContainer>
          <SocialIcon color="3B5999">
            <Facebook />
          </SocialIcon>
          <SocialIcon color="E4405F">
            <Instagram />
          </SocialIcon>
          <SocialIcon color="55ACEE">
            <Twitter />
          </SocialIcon>
          <SocialIcon color="E60023">
            <Pinterest />
          </SocialIcon>
        </SocialContainer>
      </Left>

      <Center>
        <Title>Useful Links</Title>

        <List>
          <ListItem>Home</ListItem>
          <ListItem>Cart</ListItem>
          <ListItem>Man Fashion</ListItem>
          <ListItem>Woman Fashion</ListItem>
          <ListItem>Accessories</ListItem>
          <ListItem>My Account</ListItem>
          <ListItem>Order Tracking</ListItem>
          <ListItem>Wishlist</ListItem>
          <ListItem>Terms</ListItem>
        </List>
      </Center>

      <Right>
          <Title>Contact</Title>
          <ContactItem> <Room style={{marginRight: "10px"}}/>622 Dixie Path, South Tobinchester 98336</ContactItem>
          <ContactItem> <Phone style={{marginRight: "10px"}}/> +124 56 78</ContactItem>
          <ContactItem> <Mail style={{marginRight: "10px"}}/>contect@het.patel</ContactItem>
          <Payment src="https://i.ibb.co/Qfvn4z6/payment.png"></Payment>
      </Right>
 
    </Container>
  );
}

export default Footer